"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "index", "hidden"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TabPanel = function TabPanel(props) {
  var children = props.children,
      index = props.index,
      hidden = props.hidden,
      other = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _extends2.default)({
    className: _styleModule.default.tabPanel,
    role: "tabpanel",
    hidden: hidden,
    id: "full-width-tabpanel-".concat(index),
    "aria-labelledby": "full-width-tab-".concat(index)
  }, other, {
    children: children
  }));
};

process.env.NODE_ENV !== "production" ? TabPanel.propTypes = {
  children: _propTypes.default.node,
  index: _propTypes.default.any.isRequired,
  hidden: _propTypes.default.any.isRequired
} : void 0;

var a11yProps = function a11yProps(index) {
  return {
    id: "full-width-tab-".concat(index),
    'aria-controls': "full-width-tabpanel-".concat(index)
  };
};

var AppTabNavigation = function AppTabNavigation(_ref) {
  var tabs = _ref.tabs,
      active = _ref.active,
      switchAppTab = _ref.switchAppTab;
  var theme = (0, _useTheme.default)();

  var handleChange = function handleChange(event, tab) {
    switchAppTab(tab);
  };

  var getTab = function getTab(element, index) {
    var tab = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tab.default, (0, _extends2.default)({
      className: element.className,
      id: "tabx-".concat(index),
      value: element.id,
      disableRipple: true,
      classes: {
        root: _styleModule.default.tab,
        selected: _styleModule.default.selected,
        wrapped: _styleModule.default.liked
      },
      disabled: element.disabled,
      wrapped: element.wrapped,
      label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [element.badge && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Badge.default, {
          className: "".concat(_styleModule.default.badge, " ").concat(index === 1 ? _styleModule.default.highlighted : '', " "),
          color: "secondary",
          badgeContent: element.badge.value,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'left'
          }
        }), index === 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(element.icon, {
            classes: {
              root: _styleModule.default.icon
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.tabText,
            children: element.label
          })]
        }), index === 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(element.icon, {
            classes: {
              root: _styleModule.default.icon
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.tabText,
            children: element.label
          })]
        }), index === 2 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(element.icon, {
            classes: {
              root: _styleModule.default.icon
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.tabText,
            children: element.label
          })]
        })]
      })
    }, a11yProps(index)), "tab-".concat(index));
    return tab;
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.tabHeader,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.default, {
      position: "relative",
      color: "default",
      classes: {
        root: _styleModule.default.appBar
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _styleModule.default.tabsPosition,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tabs.default, {
          classes: {
            indicator: _styleModule.default.TabIndicator
          },
          value: active,
          onChange: handleChange,
          textColor: "primary",
          variant: "fullWidth",
          "aria-label": "full width tabs",
          children: tabs.map(function (element, index) {
            return getTab(element, index);
          })
        })
      })
    }), tabs.map(function (element, index) {
      return active === element.id && /*#__PURE__*/(0, _jsxRuntime.jsx)(TabPanel, {
        index: index,
        hidden: element.id !== active,
        dir: theme.direction,
        children: element.component
      }, "tabPanel-".concat(index));
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(AppTabNavigation);

exports.default = _default;